import React, {Component} from 'react';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import store from '../../../store'

class SideMenuItem extends Component {

  isSelected() {
    const path = window.location.pathname;
    const {href} = this.props;
    return path === href;
  }

  renderClasses() {
    let {className} = this.props;

    if (!className) return '';

    if (Array.isArray(classnames)) {
      className = classnames.join(' ');
    }

    return className;
  }

  resetRegistration = (e) => {
    store.dispatch({type: 'FINISH_REGISTRATION'});
  };

  render() {
    let {title, href} = this.props;
    return (
      <li className={classnames('nav-item', {'selected ': this.isSelected()})} onClick={this.props.handleOpen}>
        <Link className="title" to={href} onClick={this.resetRegistration}>{title}</Link>
      </li>

    );
  }
}

export default SideMenuItem;


// WEBPACK FOOTER //
// ./src/components/sidenav/menu-item/index.jsx